class BlogInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.observer = null;
  }

  connectedCallback() {
    this.initializeObserver();
    window.addEventListener('popstate', this.onPopState.bind(this));
  }

  initializeObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.loadNextPage();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadNextPage() {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl || this.loading) return;
    this.loading = true;
    this.showSpinner();

    fetch(nextUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = html.getElementById('ArticleGrid');
        if (newGrid) {
          this.closest('.main-blog')?.querySelector('#ArticleGrid')?.append(...newGrid.children);
        }

        const nextTrigger = html.querySelector('blog-infinite-scroll');
        const nextNextUrl = nextTrigger?.dataset.nextUrl;
        if (nextNextUrl) {
          this.dataset.nextUrl = nextNextUrl;
        } else {
          delete this.dataset.nextUrl;
          this.observer?.disconnect();
          this.remove();
        }

      })
      .catch((e) => {
        console.error('BlogInfiniteScroll fetch error:', e);
      })
      .finally(() => {
        this.loading = false;
        this.hideSpinner();
      });
  }

  showSpinner() {
    const spinner = this.querySelector('.blog-infinite-spinner');
    if (spinner) spinner.classList.remove('hidden');
  }

  hideSpinner() {
    const spinner = this.querySelector('.blog-infinite-spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  onPopState() {
    window.location.reload();
  }
}

customElements.define('blog-infinite-scroll', BlogInfiniteScroll);
